import { USER_API_URL } from '@repo/editor/src/api/constants';
import { GenericApiResponse, PoWChallenge } from '@repo/editor/src/types';
import { tryFetchRetry } from '@repo/editor/src/utils/fetchRetry';

type GenerateTextResponse = GenericApiResponse<{
  id: string;
  status: string;
  result: {
    results: string[];
  };
}>;

export type GenerateTextInput = {
  promptId: number;
  variables: { name: string; value: string }[];
  dynamicOptions: { name: string; value: string }[];
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const createAPI = ({ url }: { url: string }) => {
  const generateTextPublic = async (
    payload: GenerateTextInput,
    powChallenge?: PoWChallenge
  ): Promise<GenerateTextResponse> => {
    return await tryFetchRetry<GenerateTextResponse>(`${url}/public/text`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-challenge-nonce': powChallenge?.nonce ?? '',
        'x-challenge-solution': powChallenge?.solution?.toString() ?? '',
      },
      body: JSON.stringify(payload),
    });
  };

  return {
    generateTextPublic,
  };
};

export default createAPI({ url: `${USER_API_URL}/generators` });
